import Vue from 'vue';

export const eventing = new Vue();



// WEBPACK FOOTER //
// ./src/components/utilities/eventing.js